//
//
//
//
//
//
//
//
//
//

import $ from 'jquery';

export default {
  name: "FileUpload",
  data() {
    return {
      value: this.initValue ? this.initValue : '',
    };
  },
  props: [ 
    'fieldName',
    'fieldGroupIndex',
    'initValue',
    'folderName',
    'onUpdate',
    'dataWowAttr'
  ],
  mounted(){

  },
  beforeDestroy() {
    $(this.$refs.input).reset();
  },
  methods: {
    onSelectFile(e){
        $(this.$refs.input).trigger('click');
    },
    onRemoveFile(e){
      this.$refs.input.value = '';
      this.value = '';
      $(this.$refs.text).val('');
      this.$emit('on-update', this.fieldName, '', this.fieldGroupIndex);
    },
    onChange(e){

        if( !e.target.files[0] ){
            return
        }

        $(this.$refs.text).val('Uploading...');

        const file = e.target.files[0];
        const imageFieldName = 'file';
        const formData = new FormData();
        const folderName = e.target.getAttribute('data-folder-name');
        formData.append('action', 'upload_file_s3' );
        formData.append('_wpnonce', AJAX_NONCE );
        formData.append('folderName', folderName );
        formData.append( imageFieldName , file, file.name );
        $.ajax({
          type: "POST",
          url: window.AJAX_URL,
          dataType: 'json',
          contentType: false,
          processData: false,
          data: formData,
          success: (data) => {
            if( data && data.success === true && data.url ){
                this.value = data.url;
                this.$emit('on-update', this.fieldName, this.value, this.fieldGroupIndex);
            }else{
                const errorMessage = data && data.message ? data.message : 'อัพโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ'
                alert(errorMessage);
            }

            $(this.$refs.text).val(this.value);
          },
          error: (data) => {
            alert('อัพโหลดไฟล์ไม่สำเร็จ กรุณาลองใหม่อีกครั้งค่ะ');
          },
        });
    }
  }
  
}
